import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class VehicleService extends Service {
  path = 'veiculo'

  async getVeiculo(placa: string, vistoriaId?: string) {
    const httpResponse = await this.httpClient.get(
      this.path +
        `/obterveiculo?placa=${placa ?? ''}&vistoriaAtivaId=${vistoriaId ?? ''}`
    )
    return httpResponse
  }

  async getFrota(params: any) {
    const httpResponse = await this.httpClient.get(
      this.path +
        `/frota?SortField=${params?.id ?? 'ID'}&Placa=${params?.placa ?? ''}`
    )
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(this.path, params)
    return httpResponse
  }

  async put(id: string, params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `?Id=${id ?? ''}`,
      params
    )
    return httpResponse
  }

  async getImplements(params: any) {
    const httpResponse = await this.httpClient.get(
      'implemento/obterimplementos',
      { params: removePropertyEmpty(params) }
    )
    return httpResponse
  }

  async getUtilization(id: string) {
    const httpResponse = await this.httpClient.get(
      `precificacao/obterutilizacaoveiculo?vistoriaId=${id}`
    )
    return httpResponse
  }

  async getVehicleColor() {
    const httpResponse = await this.httpClient.get(`cor`)
    return httpResponse
  }

  async updateVehicleResiualValue(payload: any) {
    const httpResponse = await this.httpClient.patch(
      `${this.path}/atualizavalorresidual`,
      payload
    )
    return httpResponse
  }

}
export const vehicleService = new VehicleService()
